import Vue from 'vue'
import stringExtents from '@/utils/string_ext'
import {
  GROUP_TYPE,
  PERMISSION_TYPE,
  BLOG_SOURCE_TYPES
} from '@/utils/constants'

stringExtents()

const BlockNames = {
  MapAndFly: '地圖與預定航班',
  Feature: '行程特色',
  Album: '行程相簿',
  Itinerary: '每日行程',
  MealAndHotel: '餐食住宿',
  GroupList: '出團列表',
  Remark: '優惠說明',
  OnLineAsk: '我要諮詢',
  RelatedItinerary: '相關行程'
}

const ControllerList = {
  Products: {
    name: '團別管理',
    actions: {
      Create: { name: '新增團別' },
      Clone: { name: '複製團別' },
      Delete: { name: '刪除團別' },
      UpdateBasicData: { name: '詳細資料' },
      UpdateCostData: { name: '價格維護' },
      CreateTravelerType: { name: '價格進階維護/新增旅客類型' },
      UpdateTravelerType: { name: '價格進階維護/修改旅客類型' },
      DeleteTravelType: { name: '價格進階維護/刪除旅客類型' },
      OverrideGroups: { name: '複寫旅行團' }
    }
  },
  TravelGroups: {
    name: '旅行團管理',
    actions: {
      Create: { name: '新增旅行團' },
      CreateList: { name: '新增多個旅行團' },
      Clone: { name: '複製旅行團' },
      Delete: { name: '刪除旅行團' },
      DeleteGroups: { name: '刪除多個旅行團' },
      UpdateBasicData: { name: '詳細資料' },
      UpdateAdvanceData: { name: '(進階)' },
      UpdateCostData: { name: '價格維護' },
      CreateTravelerType: { name: '價格進階維護/新增旅客類型' },
      UpdateTravelerType: { name: '價格進階維護/修改旅客類型' },
      DeleteTravelType: { name: '價格進階維護/刪除旅客類型' },
      OverrideGroups: { name: '複寫旅行團' }
    }
  }
}

const ServiceName = {
  Products: '團別',
  TravelGroups: '旅行團'
}

const ServiceMethod = {
  UpdateCost: '價格維護',
  CreateTravelType: '價格進階維護/新增旅客類型',
  UpdateTravelType: '價格進階維護/修改旅客類型',
  DeleteTravelType: '價格進階維護/刪除旅客類型',
  OverrideGroups: '複寫旅行團'
}

export const ORDER_STATUS = {
  CANCELED: -1,
  NONE: 0,
  FILLING: 1,
  OPENED: 6,
  EDITED: 7,
  COMPLETED: 2
}

Vue.mixin({
  data() {
    return {
      GROUP_TYPE,
      PERMISSION_TYPE,
      ORDER_STATUS,
      BLOG_SOURCE_TYPES
    }
  },
  methods: {
    isNormalGroup(type) {
      return type === GROUP_TYPE.NORMAL
    },
    isFirmGroup(type) {
      return type === GROUP_TYPE.FIRM
    },
    ActivityTypeName(type) {
      switch (type) {
        case 1:
          return '純單參團版(無填基資)'
        default:
          return '正常版'
      }
    },
    fantasyUrl(path) {
      if (!path) {
        return ''
      }

      if (path.startsWith('http')) {
        return path
      }

      return path.startsWith('/')
        ? `${process.env.VUE_APP_MAIN_SITE_ROOT_URL}${path}`
        : `${process.env.VUE_APP_MAIN_SITE_ROOT_URL}/${path}`
    },
    fantasyFileUrl(file) {
      return `${process.env.VUE_APP_MAIN_SITE_ROOT_URL}/Content/Files/Upload/${file}`
    },
    fantasyImageUrl(image) {
      return `${process.env.VUE_APP_IMAGE_ROOT_URL}/Content/Images/Upload/${image}`
    },
    helpImageUrl(image) {
      return `${process.env.VUE_APP_IMAGE_ROOT_URL}/Content/Images/backend/${image}`
    },
    bannerImage(image) {
      return image ? this.fantasyImageUrl(`Banner/${image}`) : ''
    },
    projectImageUrl(image) {
      return image ? this.fantasyImageUrl(`project_ptg/${image}`) : ''
    },
    productImageUrl(image) {
      return image ? this.fantasyImageUrl(`Product/${image}`) : ''
    },
    productUserImageUrl(image) {
      return image ? this.fantasyImageUrl(`UserUpload/images/${image}`) : ''
    },
    collaborateImage(image) {
      return image ? this.fantasyImageUrl(`Member/${image}`) : ''
    },
    memberImage(image) {
      return image ? this.fantasyImageUrl(`Member/${image}`) : ''
    },
    collaborateActivityImage(image) {
      return image ? this.fantasyImageUrl(`Activity/${image}`) : ''
    },
    AreaBannerImage(image) {
      return image ? this.fantasyImageUrl(`AreaBanner/${image}`) : ''
    },
    CatalogImage(image) {
      return image ? this.fantasyImageUrl(`Catalog/${image}`) : ''
    },
    CatalogBannerImage(image) {
      return image ? this.fantasyImageUrl(`CatalogBanner/${image}`) : ''
    },
    CatalogClassImage(image) {
      return image
        ? this.fantasyImageUrl(`UserUpload/images/Catalog/Class/${image}.png`)
        : ''
    },
    AirlineImage(image) {
      return image ? this.fantasyImageUrl(`AirLine/${image}`) : ''
    },
    BlogShareImage(image) {
      return image ? this.fantasyImageUrl(`Blog/${image}`) : ''
    },
    NewsImage(image) {
      return image ? this.fantasyImageUrl(`News/${image}`) : ''
    },
    TourLeaderImage(image) {
      return image ? this.fantasyImageUrl(`TourLeaders/${image}`) : ''
    },
    BlogImage(image) {
      if (!image) {
        return image
      }

      if (image.startsWith('http')) {
        return image
      }

      return image ? this.fantasyImageUrl(`Blog/${image}`) : ''
    },
    EdmImage(image) {
      return image ? this.fantasyImageUrl(`Edm/${image}`) : ''
    },
    MagazineUrl(image) {
      return image ? this.fantasyImageUrl(`Magazines/${image}`) : ''
    },
    OfferImage(image) {
      return image ? this.fantasyImageUrl(`News/${image}`) : ''
    },
    countryTemplateFlagImage(image) {
      return image ? this.fantasyImageUrl(`flags/${image}`) : ''
    },
    passportImage(image) {
      return image ? this.fantasyImageUrl(`Passport/${image}`) : ''
    },
    GiftImage(image) {
      return image ? this.fantasyImageUrl(`Gifts/${image}`) : ''
    },
    SatisfactionsImage(image, id) {
      if (!image) {
        return ''
      }
      if (!id || id.length < 8) {
        return this.fantasyImageUrl(`Satisfactions/${image}`)
      }
      let no = id.substring(0, 8)
      return no > 20251010
        ? this.fantasyImageUrl(`Satisfactions/${image}`)
        : this.fantasyImageUrl(`Blog/${image}`)
    },
    ShareStoryImage(image, id) {
      if (!image) {
        return ''
      }
      if (!id || id.length < 8) {
        return this.fantasyImageUrl(`ShareStory/${image}`)
      }
      let no = id.substring(0, 8)
      return no > 20251010
        ? this.fantasyImageUrl(`ShareStory/${image}`)
        : this.fantasyImageUrl(`Blog/${image}`)
    },
    productPreviewUrl(product) {
      const code = product.code
      const areaCode = product.area_code
      const catalogNo = product.catalog_list
        ? product.catalog_list.length > 0
          ? product.catalog_list[0]
          : ''
        : ''

      return this.fantasyUrl(
        `/Preview/ProductTour?pc=${code}&ac=${areaCode}&cn=${catalogNo}`
      )
    },
    groupUrl(group) {
      const code = group.code || group.group_code
      const areaCode = group.area_code

      const catalogList = group.catalog_list
        ? group.catalog_list.split(',')
        : []
      const catalogNo = catalogList.length > 0 ? catalogList[0] : ''

      if (group.is_template) {
        return this.fantasyUrl(
          `/Travel/ProductTour?pc=${code}&ac=${areaCode}&cn=${catalogNo}`
        )
      } else {
        return this.fantasyUrl(
          `/Travel/Tour?gc=${code}&ac=${areaCode}&cn=${catalogNo}`
        )
      }
    },
    cowellGroupUrl(group) {
      return 'https://www.fantasy-tours.com/products/group/detail/' + group
    },
    groupWordUrl(group) {
      return `/Export/Tour?gc=${group.code}`
    },
    groupPreviewUrl(group) {
      const code = group.code
      const areaCode = group.area_code

      const catalogList = group.catalog_list
        ? group.catalog_list.split(',')
        : []
      const catalogNo = catalogList.length > 0 ? catalogList[0] : ''

      return this.fantasyUrl(
        `/Preview/Tour?gc=${code}&ac=${areaCode}&cn=${catalogNo}`
      )
    },
    newsUrl(news) {
      return this.fantasyUrl(`/News/New?news_no=${news.id}&sheet=0`)
    },
    newsPreviewUrl(news) {
      if (news.type === 'B') {
        return this.fantasyUrl(`/Preview/News?news_no=${news.id}`)
      } else if (news.type === 'B1') {
        return this.fantasyUrl(`/Preview/NewsBlog?news_no=${news.id}`)
      } else {
        return this.fantasyUrl(`${news.url}`)
      }
    },
    edmUrl(news) {
      return this.fantasyUrl(`/Epapers/Content?edmNo=${news.id}`)
    },
    toruLeaderUrl(leader) {
      return this.fantasyUrl(`/tour-leaders/${leader.slug}`)
    },
    newsBlogUrl(news) {
      return this.fantasyUrl(`/News/Blog?news_no=${news.id}&sheet=0`)
    },
    blogUrl(blog) {
      return this.fantasyUrl(`/blog/post/${blog.code}`)
    },
    blogPreviewUrl(blog) {
      return `https://bliss.fantasy-tours.com/blog/posts/preview/${blog.code}`
    },
    lectureUrl(lecture) {
      return this.fantasyUrl(
        `/Follow/Activity?blog_shareID=${lecture.id}&applyCode=${lecture.apply_code}`
      )
    },
    parseDate(date) {
      let day = this.$dayjs(date)

      if (!day.isValid()) {
        day = this.$dayjs(date, 'YYYY/M/D')
      }

      return day.local()
    },
    formatMonth(date) {
      if (!date) {
        return null
      }

      const day = this.parseDate(date)

      return day.format('YYYY-MM')
    },
    formatDate(date) {
      if (!date) {
        return null
      }

      const day = this.parseDate(date)

      return day.format('YYYY-MM-DD')
    },
    formatDateWeek(date) {
      if (!date) {
        return null
      }

      const day = this.parseDate(date)

      return day.format('YYYY-MM-DD (ddd)')
    },
    formatDateDot(date) {
      if (!date) {
        return null
      }

      const day = this.parseDate(date)

      return day.format('YYYY.MM.DD')
    },
    formatDateTime(date) {
      if (!date) {
        return null
      }

      const day = this.parseDate(date)

      return day.format('YYYY-MM-DD HH:mm:ss')
    },
    formatDates(dates) {
      if (!dates) {
        return []
      }
      if (!Array.isArray(dates)) {
        return []
      }

      return dates
        .map(date => this.$dayjs(date).format('YYYY-MM-DD'))
        .join(' - ')
    },
    formatTimes(start, end) {
      const start_time = this.$dayjs(start).format('HH:mm')
      const end_time = this.$dayjs(end).format('HH:mm')

      return `${start_time} ~ ${end_time}`
    },
    StripHTML(str) {
      return str.replace(/<\/?[^>]+(>|$)/g, '')
    },
    /**
     * Currency format(num, n = 2, x)
     *
     * @param num number
     * @param n integer length of decimal
     * @param x integer length of sections
     */
    formatCurrency(num, n = 0, x = null) {
      if (!num) {
        return num
      }

      const re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')'
      return num.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,')
    },
    whetherStatus(active) {
      return this.$t(active ? 'attributes.yes' : 'attributes.no')
    },
    activeStatus(active) {
      return this.$t(active ? 'attributes.enabled' : 'attributes.disabled')
    },
    displayStatus(active) {
      return this.$t(active ? 'attributes.display' : 'attributes.hide')
    },
    shelveStatus(shelveOn) {
      return this.$t(
        shelveOn ? 'attributes.shelve_on' : 'attributes.shelve_off'
      )
    },
    publishStatus(publish) {
      return this.$t(
        publish ? 'attributes.published' : 'attributes.unpublished'
      )
    },
    groupShelveStatus(group) {
      return this.$t(
        group.is_deprecated
          ? 'attributes.deprecated'
          : group.shelve_on
          ? 'attributes.shelve_on'
          : 'attributes.shelve_off'
      )
    },
    confirmedStatus(confirmed) {
      return this.$t(confirmed ? 'attributes.passed' : 'attributes.unconfirmed')
    },
    includedFlag(flag) {
      return this.$t(flag ? 'attributes.included' : 'attributes.excluded')
    },
    visaFlag(flag) {
      if (flag === 'Y') {
        return this.$t('attributes.included')
      }
      if (flag === 'N') {
        return this.$t('attributes.excluded')
      }
      if (flag === 'X') {
        return this.$t('attributes.visa_free')
      }
      return ''
    },
    flyStatusIcon(active) {
      return this.$t(active ? 'check-bold' : 'close')
    },
    flyStatusColor(active) {
      return this.$t(active ? 'is-success' : 'is-dark')
    },
    bedTypeName(type) {
      switch (type) {
        case 'Bed':
          return this.$t('attributes.traveler_bed_type_bed')
        case 'NoBed':
          return this.$t('attributes.traveler_bed_type_no_bed')
        case 'AddBed':
          return this.$t('attributes.traveler_bed_type_add_bed')
        case 'Infant':
          return this.$t('attributes.traveler_bed_type_infant')
        default:
          return this.$t('message.invalid_parameter')
      }
    },
    areaActionName(action) {
      switch (action) {
        case 'A':
          return this.$t('attributes.situation_action_a')
        case 'B':
          return this.$t('attributes.situation_action_b')
        default:
          return this.$t('message.invalid_parameter')
      }
    },
    role_name(role) {
      return this.$t(
        role === 'manager' ? 'attributes.manager' : 'attributes.member'
      )
    },
    employeeStatus(status) {
      return this.$t(
        status === 1
          ? 'attributes.employee_in_service'
          : 'attributes.employee_resignation'
      )
    },
    employeeName(code, name) {
      return `[${code}] ${name}`
    },
    employeeFullName(employee) {
      if (!employee) {
        return ''
      }

      return this.employeeName(employee.emp_code, employee.name)
    },
    salesName(item) {
      if (!item.sales_code) {
        return this.$t('attributes.order_no_sales')
      }

      return this.employeeName(item.sales_code, item.sales_name)
    },
    operatorName(item) {
      if (!item.operator_code) {
        return ''
      }

      return this.employeeName(item.operator_code, item.operator_name)
    },
    demandSalesName(item) {
      if (!item.demand_sales) {
        return this.$t('attributes.order_no_sales')
      }

      return this.employeeName(item.demand_sales, item.demand_sales_name)
    },
    reviewerName(item) {
      if (!item.reviewer_code) {
        return ''
      }

      return this.employeeName(item.reviewer_code, item.reviewer_name)
    },
    accountantName(item) {
      if (!item.accountant_code) {
        return ''
      }

      return this.employeeName(item.accountant_code, item.accountant_name)
    },
    voiderName(item) {
      if (!item.voider_code) {
        return ''
      }

      return this.employeeName(item.voider_code, item.voider_name)
    },
    clearTag(str) {
      return str.replace(/<\/?[^>]+(>|$)/g, '')
    },
    GetProductTypes() {
      return [
        { name: '一般', value: '一般' },
        { name: '無出發日', value: '範本' }
      ]
    },
    ProductType(type) {
      switch (type) {
        case '一般':
          return '一般'
        case '範本':
          return '無出發日'
        default:
          return '一般'
      }
    },
    GetTravelGroupTypes() {
      return [
        { name: '一般', value: '一般' },
        { name: '無出發日', value: '範本' }
      ]
    },
    TravelGroupType(type) {
      switch (type) {
        case '一般':
          return '一般'
        case '範本':
          return '無出發日'
        case '企業':
          return '企業'
        default:
          return '一般'
      }
    },
    newsType(type) {
      switch (type) {
        case 'A':
          return this.$t('attributes.news_link_type')
        case 'B':
          return this.$t('attributes.news_normal_type')
        case 'B1':
          return this.$t('attributes.news_blog_type')
        default:
          return type
      }
    },
    edmType(type) {
      switch (type) {
        case 'A':
          return this.$t('attributes.edm_link_type')
        case 'B':
          return this.$t('attributes.edm_normal_type')
        default:
          return type
      }
    },
    offerType(type) {
      switch (type) {
        case 'C':
          return this.$t('attributes.offer_area_type')
        case 'D':
          return this.$t('attributes.offer_bank_type')
        default:
          return type
      }
    },
    ControllerActionPath(controllerName, actionName) {
      const controller = ControllerList[controllerName] || {
        name: controllerName,
        actions: {}
      }
      const action = controller.actions[actionName] || { name: actionName }

      return `${controller.name}/${action.name}`
    },
    ServiceMethodPath(service, method) {
      const serviceName = ServiceName[service] || service
      const methodName = ServiceMethod[method] || method

      return `${serviceName}/${methodName}`
    },
    GroupBlockName(type) {
      return BlockNames[type] || '區塊名稱錯誤'
    },
    isMobileDevice() {
      return screen.width <= 1023
    },
    isDesktop() {
      return !this.isMobileDevice()
    },
    offerPreviewUrl(offer) {
      return this.fantasyUrl(
        `/Preview/Bank?id=${offer.id}&subarea=${offer.area_name}`
      )
    },
    formatAirlineName(airline) {
      if (!airline) {
        return ''
      }

      return (
        `${airline.code.trim()} - ${airline.name.trim()}` +
        `(${airline.english_name ? airline.english_name.trim() : ''})`
      )
    }
  }
})
